module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0006-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/007foreword#for"
    }
  }, [_vm._v("FOREWORD")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/007foreword#for"
    }
  }, [_vm._v("12")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/008introduction#int"
    }
  }, [_vm._v("INTRODUCTION")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/008introduction#int"
    }
  }, [_vm._v("14")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/009keep#keep"
    }
  }, [_vm._v("Some Things to Keep in Mind")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/009keep#keep"
    }
  }, [_vm._v("16")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/010unusual#unu"
    }
  }, [_vm._v("Unusual Ingredients")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/010unusual#unu"
    }
  }, [_vm._v("22")])]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0006-02.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/011part01#part1"
    }
  }, [_vm._v("BREAKFAST")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1t"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/012part01chapter01#part1ch1"
    }
  }, [_vm._v("Avocado + Kimchi Toast")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/012part01chapter01#part1ch1"
    }
  }, [_vm._v("26")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/013part01chapter02#part1ch2"
    }
  }, [_vm._v("Gravlax with Caper Cream Cheese")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/013part01chapter02#part1ch2"
    }
  }, [_vm._v("28")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/014part01chapter03#part1ch3"
    }
  }, [_vm._v("Olive Oil–Fried Eggs with Yogurt + Lemon")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/014part01chapter03#part1ch3"
    }
  }, [_vm._v("31")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/015part01chapter04#part1ch4"
    }
  }, [_vm._v("Green Eggs With (or Without) Ham")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/015part01chapter04#part1ch4"
    }
  }, [_vm._v("33")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/016part01chapter05#part1ch5"
    }
  }, [_vm._v("Chilaquiles with Roasted Tomato Salsa")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/016part01chapter05#part1ch5"
    }
  }, [_vm._v("36")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/017part01chapter06#part1ch6"
    }
  }, [_vm._v("Bread, Sausage + Apple Hash")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/017part01chapter06#part1ch6"
    }
  }, [_vm._v("40")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/018part01chapter07#part1ch7"
    }
  }, [_vm._v("Sour Cream Pancakes with Roasted Blueberries")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/018part01chapter07#part1ch7"
    }
  }, [_vm._v("43")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/019part01chapter08#part1ch8"
    }
  }, [_vm._v("Apple + Toasted Oat Muffins")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/019part01chapter08#part1ch8"
    }
  }, [_vm._v("46")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/020part01chapter09#part1ch9"
    }
  }, [_vm._v("Raspberry Jam Buns with Crème Fraîche Frosting")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/020part01chapter09#part1ch9"
    }
  }, [_vm._v("49")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/021part01chapter10#part1ch10"
    }
  }, [_vm._v("Everything Biscuits")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/021part01chapter10#part1ch10"
    }
  }, [_vm._v("53")])]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0007-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/022part02#part2"
    }
  }, [_vm._v("SOUPS + SALADS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1t"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/023part02chapter01#part2ch1"
    }
  }, [_vm._v("A Bowl of Anything Soup, Anytime")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/023part02chapter01#part2ch1"
    }
  }, [_vm._v("58")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/024part02chapter02#part2ch2"
    }
  }, [_vm._v("Roasted Red Pepper + Pear Soup")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/024part02chapter02#part2ch2"
    }
  }, [_vm._v("61")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/025part02chapter03#part2ch3"
    }
  }, [_vm._v("Parmesan Soup with Tiny Pasta + Peas")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/025part02chapter03#part2ch3"
    }
  }, [_vm._v("64")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/026part02chapter04#part2ch4"
    }
  }, [_vm._v("Spring Pea, Leek + Herb Soup")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/026part02chapter04#part2ch4"
    }
  }, [_vm._v("67")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/027part02chapter05#part2ch5"
    }
  }, [_vm._v("Snow-Day Udon Soup")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/027part02chapter05#part2ch5"
    }
  }, [_vm._v("70")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/028part02chapter06#part2ch6"
    }
  }, [_vm._v("Clam, Sweet Potato + Miso Soup")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/028part02chapter06#part2ch6"
    }
  }, [_vm._v("72")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/029part02chapter07#part2ch7"
    }
  }, [_vm._v("Aunt Renee’s Chicken Soup")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/029part02chapter07#part2ch7"
    }
  }, [_vm._v("74")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/030part02chapter08#part2ch8"
    }
  }, [_vm._v("Corn + Potato Chowder")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/030part02chapter08#part2ch8"
    }
  }, [_vm._v("78")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/031part02chapter09#part2ch9"
    }
  }, [_vm._v("Bibb Lettuce with Garlic Dressing")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/031part02chapter09#part2ch9"
    }
  }, [_vm._v("80")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/032part02chapter10#part2ch10"
    }
  }, [_vm._v("Julia’s Caesar")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/032part02chapter10#part2ch10"
    }
  }, [_vm._v("83")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/033part02chapter11#part2ch11"
    }
  }, [_vm._v("Shaved Carrot + Avocado Salad with Tahini")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/033part02chapter11#part2ch11"
    }
  }, [_vm._v("84")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/034part02chapter12#part2ch12"
    }
  }, [_vm._v("Gus’s House Salad")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/034part02chapter12#part2ch12"
    }
  }, [_vm._v("87")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/035part02chapter13#part2ch13"
    }
  }, [_vm._v("Beet + Just-Barely-Pickled Cucumber Salad")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/035part02chapter13#part2ch13"
    }
  }, [_vm._v("88")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/036part02chapter14#part2ch14"
    }
  }, [_vm._v("Zucchini, Red Onion + Pistachio Salad")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/036part02chapter14#part2ch14"
    }
  }, [_vm._v("91")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/037part02chapter15#part2ch15"
    }
  }, [_vm._v("Radicchio Slaw with Warm Bacon Dressing")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/037part02chapter15#part2ch15"
    }
  }, [_vm._v("94")])]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0007-02.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/038part03#part3"
    }
  }, [_vm._v("VEGETABLES")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1t"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/039part03chapter01#part3ch1"
    }
  }, [_vm._v("Tin-Foil Kale + Cherry Tomatoes")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/039part03chapter01#part3ch1"
    }
  }, [_vm._v("98")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/040part03chapter02#part3ch2"
    }
  }, [_vm._v("Swiss Chard with Ginger + Coconut")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/040part03chapter02#part3ch2"
    }
  }, [_vm._v("100")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/041part03chapter03#part3ch3"
    }
  }, [_vm._v("String Beans with Pork, Ginger + Red Chile")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/041part03chapter03#part3ch3"
    }
  }, [_vm._v("103")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/042part03chapter04#part3ch4"
    }
  }, [_vm._v("Creamed Corn")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/042part03chapter04#part3ch4"
    }
  }, [_vm._v("104")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/043part03chapter05#part3ch5"
    }
  }, [_vm._v("Zucchini + Nigella Fritters")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/043part03chapter05#part3ch5"
    }
  }, [_vm._v("107")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/044part03chapter06#part3ch6"
    }
  }, [_vm._v("Asparagus with Browned Butter + Hazelnuts")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/044part03chapter06#part3ch6"
    }
  }, [_vm._v("109")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/045part03chapter07#part3ch7"
    }
  }, [_vm._v("Kinda, Sorta Patatas Bravas")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/045part03chapter07#part3ch7"
    }
  }, [_vm._v("110")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/046part03chapter08#part3ch8"
    }
  }, [_vm._v("Grace’s Sweet Potatoes")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/046part03chapter08#part3ch8"
    }
  }, [_vm._v("112")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/047part03chapter09#part3ch9"
    }
  }, [_vm._v("Roasted Radishes with Kalamata Dressing")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/047part03chapter09#part3ch9"
    }
  }, [_vm._v("114")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/048part03chapter10#part3ch10"
    }
  }, [_vm._v("Roasted Mushrooms on Toast")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/048part03chapter10#part3ch10"
    }
  }, [_vm._v("116")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/049part03chapter11#part3ch11"
    }
  }, [_vm._v("Cauliflower with Anchovy Bread Crumbs")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/049part03chapter11#part3ch11"
    }
  }, [_vm._v("118")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/050part03chapter12#part3ch12"
    }
  }, [_vm._v("Roasted Scallion + Chive Dip")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/050part03chapter12#part3ch12"
    }
  }, [_vm._v("119")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/051part03chapter13#part3ch13"
    }
  }, [_vm._v("Smoky Eggplant Dip with Yogurt + Za’atar")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/051part03chapter13#part3ch13"
    }
  }, [_vm._v("122")])]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0008-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/052part04#part4"
    }
  }, [_vm._v("GRAINS, BEANS + PASTA")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1t"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/053part04chapter01#part4ch1"
    }
  }, [_vm._v("Kimchi Fried Rice with Scallion Salad")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/053part04chapter01#part4ch1"
    }
  }, [_vm._v("127")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/054part04chapter02#part4ch2"
    }
  }, [_vm._v("Best Rice Pilaf with Roasted Red Cabbage")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/054part04chapter02#part4ch2"
    }
  }, [_vm._v("129")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/055part04chapter03#part4ch3"
    }
  }, [_vm._v("Potluck Quinoa")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/055part04chapter03#part4ch3"
    }
  }, [_vm._v("132")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/056part04chapter04#part4ch4"
    }
  }, [_vm._v("Kasha + Mushrooms with Crispy Salami")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/056part04chapter04#part4ch4"
    }
  }, [_vm._v("134")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/057part04chapter05#part4ch5"
    }
  }, [_vm._v("Curried Red Lentils with Coconut Milk")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/057part04chapter05#part4ch5"
    }
  }, [_vm._v("136")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/058part04chapter06#part4ch6"
    }
  }, [_vm._v("Chopped Chickpea Salad")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/058part04chapter06#part4ch6"
    }
  }, [_vm._v("139")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/059part04chapter07#part4ch7"
    }
  }, [_vm._v("Crispy Hominy + Cheddar Fritters")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/059part04chapter07#part4ch7"
    }
  }, [_vm._v("140")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/060part04chapter08#part4ch8"
    }
  }, [_vm._v("Orecchiette with Spicy Sausage + Parmesan")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/060part04chapter08#part4ch8"
    }
  }, [_vm._v("142")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/061part04chapter09#part4ch9"
    }
  }, [_vm._v("A Nice Lasagna")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/061part04chapter09#part4ch9"
    }
  }, [_vm._v("145")])]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0008-02.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/062part05#part5"
    }
  }, [_vm._v("MEAT + POULTRY")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1t"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/063part05chapter01#part5ch1"
    }
  }, [_vm._v("Country Ham with Henley Mustard Sauce")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/063part05chapter01#part5ch1"
    }
  }, [_vm._v("151")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/064part05chapter02#part5ch2"
    }
  }, [_vm._v("Roast Pork Loin with Herbs + Cream Cheese")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/064part05chapter02#part5ch2"
    }
  }, [_vm._v("152")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/065part05chapter03#part5ch3"
    }
  }, [_vm._v("Ribs with Gochujang, Fish Sauce + Honey")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/065part05chapter03#part5ch3"
    }
  }, [_vm._v("155")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/066part05chapter04#part5ch4"
    }
  }, [_vm._v("All-Day Pork Shoulder with Apple Cider")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/066part05chapter04#part5ch4"
    }
  }, [_vm._v("158")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/067part05chapter05#part5ch5"
    }
  }, [_vm._v("Grilled Skirt Steak with Pickled Jalapeño Relish")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/067part05chapter05#part5ch5"
    }
  }, [_vm._v("159")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/068part05chapter06#part5ch6"
    }
  }, [_vm._v("Brisket with Apricots + Prunes")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/068part05chapter06#part5ch6"
    }
  }, [_vm._v("162")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/069part05chapter07#part5ch7"
    }
  }, [_vm._v("Homemade Merguez with Herby Yogurt")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/069part05chapter07#part5ch7"
    }
  }, [_vm._v("164")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/070part05chapter08#part5ch8"
    }
  }, [_vm._v("Turkey + Ricotta Meatballs")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/070part05chapter08#part5ch8"
    }
  }, [_vm._v("168")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/071part05chapter09#part5ch9"
    }
  }, [_vm._v("Dad’s Chicken + Leeks")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/071part05chapter09#part5ch9"
    }
  }, [_vm._v("172")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/072part05chapter10#part5ch10"
    }
  }, [_vm._v("Roast Chicken with Fennel, Rosemary + Lemon")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/072part05chapter10#part5ch10"
    }
  }, [_vm._v("174")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/073part05chapter11#part5ch11"
    }
  }, [_vm._v("Jennie’s Chicken Pelau")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/073part05chapter11#part5ch11"
    }
  }, [_vm._v("176")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/074part05chapter12#part5ch12"
    }
  }, [_vm._v("Buttermilk + Pimentón Fried Chicken")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/074part05chapter12#part5ch12"
    }
  }, [_vm._v("180")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/075part05chapter13#part5ch13"
    }
  }, [_vm._v("Indecision Grilled Chicken")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/075part05chapter13#part5ch13"
    }
  }, [_vm._v("182")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/076part05chapter14#part5ch14"
    }
  }, [_vm._v("Chicken + Pea Skillet Pie")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/076part05chapter14#part5ch14"
    }
  }, [_vm._v("184")])]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0009-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/077part06#part6"
    }
  }, [_vm._v("SHELLFISH + FISH")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/078part06chapter01#part6ch1"
    }
  }, [_vm._v("Greek-ish Grilled Shrimp")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/078part06chapter01#part6ch1"
    }
  }, [_vm._v("190")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1t"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/079part06chapter02#part6ch2"
    }
  }, [_vm._v("Old Bay Shrimp Cocktail")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/079part06chapter02#part6ch2"
    }
  }, [_vm._v("192")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/080part06chapter03#part6ch3"
    }
  }, [_vm._v("Korean Clambake")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/080part06chapter03#part6ch3"
    }
  }, [_vm._v("195")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/081part06chapter04#part6ch4"
    }
  }, [_vm._v("Scallops with Chile-and-Parsley Bread Crumbs")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/081part06chapter04#part6ch4"
    }
  }, [_vm._v("200")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/082part06chapter05#part6ch5"
    }
  }, [_vm._v("Broiled Anything with Garlic + Parsley Butter")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/082part06chapter05#part6ch5"
    }
  }, [_vm._v("202")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/083part06chapter06#part6ch6"
    }
  }, [_vm._v("Roasted Salmon with Maple + Soy")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/083part06chapter06#part6ch6"
    }
  }, [_vm._v("205")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/084part06chapter07#part6ch7"
    }
  }, [_vm._v("Crispy Fish with Bacon + Chives")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/084part06chapter07#part6ch7"
    }
  }, [_vm._v("206")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/085part06chapter08#part6ch8"
    }
  }, [_vm._v("Flounder with Roasted Tomatoes + Black Olives")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/085part06chapter08#part6ch8"
    }
  }, [_vm._v("209")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/086part06chapter09#part6ch9"
    }
  }, [_vm._v("Halibut with Chermoula in Parchment")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/086part06chapter09#part6ch9"
    }
  }, [_vm._v("211")])]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0009-02.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/087part07#part7"
    }
  }, [_vm._v("DESSERTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1t"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/088part07chapter01#part7ch1"
    }
  }, [_vm._v("Sliced Citrus with Pomegranate + Pistachios")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/088part07chapter01#part7ch1"
    }
  }, [_vm._v("217")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/089part07chapter02#part7ch2"
    }
  }, [_vm._v("Blood Orange Granita with Mascarpone")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/089part07chapter02#part7ch2"
    }
  }, [_vm._v("218")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/090part07chapter03#part7ch3"
    }
  }, [_vm._v("Coconut “Ice Cream” with Lime + Mango")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/090part07chapter03#part7ch3"
    }
  }, [_vm._v("221")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/091part07chapter04#part7ch4"
    }
  }, [_vm._v("Peach + Bourbon Milkshakes")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/091part07chapter04#part7ch4"
    }
  }, [_vm._v("222")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/092part07chapter05#part7ch5"
    }
  }, [_vm._v("Happy Wife, Happy Life Chocolate Cake")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/092part07chapter05#part7ch5"
    }
  }, [_vm._v("224")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/093part07chapter06#part7ch6"
    }
  }, [_vm._v("Afternoon Cake")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/093part07chapter06#part7ch6"
    }
  }, [_vm._v("229")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/094part07chapter07#part7ch7"
    }
  }, [_vm._v("Apricot Upside-Down Skillet Cake")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/094part07chapter07#part7ch7"
    }
  }, [_vm._v("231")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/095part07chapter08#part7ch8"
    }
  }, [_vm._v("Berry + Buttermilk Cobbler")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/095part07chapter08#part7ch8"
    }
  }, [_vm._v("234")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/096part07chapter09#part7ch9"
    }
  }, [_vm._v("Feel-Better-Soon Cookies")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/096part07chapter09#part7ch9"
    }
  }, [_vm._v("237")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/097part07chapter10#part7ch10"
    }
  }, [_vm._v("Hope + Winky’s Cookies")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/097part07chapter10#part7ch10"
    }
  }, [_vm._v("241")])]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0010-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/098part08#part8"
    }
  }, [_vm._v("A FEW DRINKS + SOME THINGS TO KEEP ON HAND")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1t"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/099part08chapter01#part8ch1"
    }
  }, [_vm._v("Ginger + Honey Arnold Palmers")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/099part08chapter01#part8ch1"
    }
  }, [_vm._v("244")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/100part08chapter02#part8ch2"
    }
  }, [_vm._v("Whiskey + Maple Syrup Sour")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/100part08chapter02#part8ch2"
    }
  }, [_vm._v("247")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/101part08chapter03#part8ch3"
    }
  }, [_vm._v("Paloma Slushies")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/101part08chapter03#part8ch3"
    }
  }, [_vm._v("248")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/102part08chapter04#part8ch4"
    }
  }, [_vm._v("Black Pepper Bloody Marys")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/102part08chapter04#part8ch4"
    }
  }, [_vm._v("251")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/103part08chapter05#part8ch5"
    }
  }, [_vm._v("Apple Cider + Ginger Beer Punch")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/103part08chapter05#part8ch5"
    }
  }, [_vm._v("252")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/104part08chapter06#part8ch6"
    }
  }, [_vm._v("Roasted Hazelnut Milk with Cinnamon")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/104part08chapter06#part8ch6"
    }
  }, [_vm._v("253")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/105part08chapter07#part8ch7"
    }
  }, [_vm._v("Cold Elixir")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/105part08chapter07#part8ch7"
    }
  }, [_vm._v("255")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/106part08chapter08#part8ch8"
    }
  }, [_vm._v("Fromage Fort")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/106part08chapter08#part8ch8"
    }
  }, [_vm._v("256")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/107part08chapter09#part8ch9"
    }
  }, [_vm._v("Cilantro + Scallion Sauce")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/107part08chapter09#part8ch9"
    }
  }, [_vm._v("257")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/108part08chapter10#part8ch10"
    }
  }, [_vm._v("Arugula + Walnut Pesto")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/108part08chapter10#part8ch10"
    }
  }, [_vm._v("259")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/109part08chapter11#part8ch11"
    }
  }, [_vm._v("Chile, Lemon + Parsley Crème Fraîche")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/109part08chapter11#part8ch11"
    }
  }, [_vm._v("261")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/110part08chapter12#part8ch12"
    }
  }, [_vm._v("No-Sweat Vinaigrette")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/110part08chapter12#part8ch12"
    }
  }, [_vm._v("262")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/111part08chapter13#part8ch13"
    }
  }, [_vm._v("Spicy Honey")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/111part08chapter13#part8ch13"
    }
  }, [_vm._v("264")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/112part08chapter14#part8ch14"
    }
  }, [_vm._v("Molasses Barbecue Sauce")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/112part08chapter14#part8ch14"
    }
  }, [_vm._v("266")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/113part08chapter15#part8ch15"
    }
  }, [_vm._v("Pickled Red Onions")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/113part08chapter15#part8ch15"
    }
  }, [_vm._v("267")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/114part08chapter16#part8ch16"
    }
  }, [_vm._v("A Jar of Raspberry + Blackberry Jam")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/114part08chapter16#part8ch16"
    }
  }, [_vm._v("268")])]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0010-02.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/115part09#part9"
    }
  }, [_vm._v("SEVEN LISTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1t"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/116part09chapter01#part9ch1"
    }
  }, [_vm._v("Seven Easy-but-Memorable Bites to Have with Drinks")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/116part09chapter01#part9ch1"
    }
  }, [_vm._v("274")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/117part09chapter02#part9ch2"
    }
  }, [_vm._v("Seven Things to Do with a Can of Chickpeas")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/117part09chapter02#part9ch2"
    }
  }, [_vm._v("275")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/118part09chapter03#part9ch3"
    }
  }, [_vm._v("Seven Things to Do with Leftover Roast Chicken")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/118part09chapter03#part9ch3"
    }
  }, [_vm._v("276")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/119part09chapter04#part9ch4"
    }
  }, [_vm._v("Seven Things to Do with Ground Meat")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/119part09chapter04#part9ch4"
    }
  }, [_vm._v("277")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/120part09chapter05#part9ch5"
    }
  }, [_vm._v("Seven Ways with Mussels")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/120part09chapter05#part9ch5"
    }
  }, [_vm._v("279")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/121part09chapter06#part9ch6"
    }
  }, [_vm._v("Seven Things to Do with Pizza Dough")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/121part09chapter06#part9ch6"
    }
  }, [_vm._v("281")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/122part09chapter07#part9ch7"
    }
  }, [_vm._v("Seven Easy-but-Memorable Desserts")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/122part09chapter07#part9ch7"
    }
  }, [_vm._v("282")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/123menu#menu"
    }
  }, [_vm._v("MENU SUGGESTIONS")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/123menu#menu"
    }
  }, [_vm._v("286")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/124give#give"
    }
  }, [_vm._v("GIVE BACK")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/124give#give"
    }
  }, [_vm._v("288")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/124give#pg288lev1"
    }
  }, [_vm._v("National Organizations")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/124give#pg288lev1"
    }
  }, [_vm._v("288")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/124give#pg288lev2"
    }
  }, [_vm._v("International Organizations")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/124give#pg288lev2"
    }
  }, [_vm._v("288")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/124give#pg289lev1"
    }
  }, [_vm._v("New York City Organizations")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/124give#pg289lev1"
    }
  }, [_vm._v("289")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/124give#pg289lev2"
    }
  }, [_vm._v("Local Organizations")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/124give#pg289lev2"
    }
  }, [_vm._v("289")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/124give#pg289lev3"
    }
  }, [_vm._v("Also")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/124give#pg289lev3"
    }
  }, [_vm._v("289")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/125acknowledgments#ack"
    }
  }, [_vm._v("ACKNOWLEDGMENTS")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/125acknowledgments#ack"
    }
  }, [_vm._v("290")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/126index#ind"
    }
  }, [_vm._v("INDEX")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/126index#ind"
    }
  }, [_vm._v("294")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/127author#aut"
    }
  }, [_vm._v("ABOUT THE AUTHOR")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/127author#aut"
    }
  }, [_vm._v("306")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59bf3913","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/006-contents.vue
// module id = 72
// module chunks = 0